import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || '';

/**
 * Get all submissions (filtered by user role)
 * - super_admin/developer: see all submissions
 * - user: see only their own submissions
 */
export const getSubmissions = async () => {
    const response = await axios.get(`${API_BASE_URL}/api/submissions`, {
        withCredentials: true
    });
    return response.data;
};

/**
 * Get a single submission by ID
 * @param {string} id - Submission MongoDB ID
 */
export const getSubmission = async (id) => {
    const response = await axios.get(`${API_BASE_URL}/api/submissions/${id}`, {
        withCredentials: true
    });
    return response.data;
};

/**
 * Update a submission (admin only)
 * @param {string} id - Submission MongoDB ID
 * @param {Object} data - Update data (status, approvalAmount, fundedAmount, termLength)
 */
export const updateSubmission = async (id, data) => {
    const response = await axios.patch(`${API_BASE_URL}/api/submissions/${id}`, data, {
        withCredentials: true
    });
    return response.data;
};

/**
 * Get submission statistics (admin only)
 */
export const getSubmissionStats = async () => {
    const response = await axios.get(`${API_BASE_URL}/api/submissions/stats/summary`, {
        withCredentials: true
    });
    return response.data;
};



